module.exports = __webpack_public_path__ + "assets/icons/ic_insert_photo-ddcb.svg";